class TabNavigation extends HTMLElement {
  constructor() {
    super();

    this.buttons = this.querySelectorAll('.tab-link');
    this.contents = document.querySelectorAll('.tab-content');

    for (const button of this.buttons) {
      button.addEventListener('click', (event) => {
        const target = button.dataset.tabId;
        this.activateTab(target);

        this.buttons.forEach((btn) => {
          btn.classList.toggle('is-active', btn === button);
        });
      });
    }
  }

  activateTab(target) {
    this.contents.forEach((content) => {
      content.classList.toggle('is-active', content.id === target);
    });

    window.dispatchEvent(
      new CustomEvent('toolpedia:tab-change', {
        detail: {
          tabId: target,
        },
      }),
    );
  }
}

if (!customElements.get('tab-nav')) {
  customElements.define('tab-nav', TabNavigation);
}

const initToolpediaVideoPopups = (scope = document) => {
  scope.querySelectorAll('[data-toolpedia-video-popups]').forEach((root) => {
    if (root.dataset.toolpediaVideoInit === 'true') return;

    root.dataset.toolpediaVideoInit = 'true';

    root.querySelectorAll('[data-video-popup-trigger]').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const modal = document.getElementById(trigger.dataset.modalId);
        if (!modal) return;

        const video = modal.querySelector('video');
        modal.show(trigger);

        if (video) {
          video.muted = false;
          const playPromise = video.play();

          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {});
          }
        }
      });
    });
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initToolpediaVideoPopups());
} else {
  initToolpediaVideoPopups();
}

document.addEventListener('shopify:section:load', (event) => {
  initToolpediaVideoPopups(event.target);
});
